module.exports = __webpack_public_path__ + "media/IBMPlexSans-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Regular.eot
// module id = 467
// module chunks = 62